/*
    This file contains the implementation of the scanner
 */

export class Scanner {
    constructor() {
        this.url = null;
        this.apiKey = null;

        this.scans = [];
        this.scanLoop = null;

        this.root = null;
        this.video = null;
        this.buffer = null;
        this.scanView = null;

        // callbacks
        this.onSuccess = function () { };
        this.onFailure = function () { };

        // bind methods
        this.init = this.init.bind(this);
        this.dispose = this.dispose.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.scan = this.scan.bind(this);
    }

    async init(url, apiKey, styles = null) {
        this.url = url;
        this.apiKey = apiKey;

        this.root = document.getElementById('veristamp');

        this.video = document.createElement('video');
        this.video.setAttribute('id', 'camera-video');
        this.video.setAttribute('autoplay', 'true');
        this.video.setAttribute('playsinline', 'true');
        this.video.setAttribute('muted', 'true');
        if (styles && styles.cameraVideo) {
            for (const key in styles.cameraVideo) {
                this.video.style[key] = styles.cameraVideo[key];
            }
        } else {
            this.video.style.maxWidth = '100%';
            this.video.style.maxHeight = '100%';
            this.video.style.position = 'absolute';
            this.video.style.top = '50%';
            this.video.style.left = '50%';
            this.video.style.transform = 'translate(-50%, -50%)';
        }
        this.root.appendChild(this.video);


        this.buffer = document.createElement('canvas');
        this.buffer.setAttribute('id', 'camera-buffer');
        this.buffer.style.display = 'none';
        this.root.appendChild(this.buffer);

        this.scanView = document.createElement('div');
        this.scanView.setAttribute('id', 'scan-view');
        if (styles && styles.scanView) {
            for (const key in styles.scanView) {
                this.scanView.style[key] = styles.scanView[key];
            }
        } else {
            this.scanView.style.position = 'absolute';
            this.scanView.style.top = '50%';
            this.scanView.style.left = '50%';
            this.scanView.style.transform = 'translate(-50%, -50%)';
            this.scanView.style.width = '220px';
            this.scanView.style.height = '80px';
            this.scanView.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
            this.scanView.style.border = '2px solid rgba(255, 255, 255, 0.5)';
        }
        this.root.appendChild(this.scanView);

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            var constraints = { video: { facingMode: 'environment' } };
            try {
                var stream = await navigator.mediaDevices.getUserMedia(constraints);
                this.video.srcObject = stream;
                this.video.addEventListener('loadedmetadata', () => {
                    this.buffer.width = this.video.videoWidth;
                    this.buffer.height = this.video.videoHeight;
                });
            } catch (error) {
                console.error('Error accessing the camera:', error);
                throw error;
            }
        } else {
            console.error('getUserMedia is not supported in this browser.');
            throw new Error('getUserMedia is not supported in this browser.');
        }
    }

    dispose() {
        this.stop();
        this.root.removeChild(this.video);
        this.root.removeChild(this.buffer);
        this.root.removeChild(this.scanView);
        this.root = null;
    }

    start() {
        this.scanLoop = setTimeout(this.scan, 100);
    }

    stop() {
        clearTimeout(this.scanLoop);
    }

    async scan() {
        const bufferContext = this.buffer.getContext('2d');
        bufferContext.drawImage(this.video, 0, 0, this.buffer.width, this.buffer.height);

        const videoRect = this.video.getBoundingClientRect();
        const scanViewRect = this.scanView.getBoundingClientRect();

        const scalingFactor = this.buffer.width / videoRect.width;
        var scanRegion = {
            left: (scanViewRect.left - videoRect.left) * scalingFactor,
            top: (scanViewRect.top - videoRect.top) * scalingFactor,
            width: scanViewRect.width * scalingFactor,
            height: scanViewRect.height * scalingFactor
        };

        try {
            var imageData = bufferContext.getImageData(scanRegion.left, scanRegion.top, scanRegion.width, scanRegion.height);
        } catch (error) {
            return;
        }
        var canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        var context = canvas.getContext('2d');
        context.putImageData(imageData, 0, 0);
        var data = canvas.toDataURL('image/png');

        const payload = {
            image: data
        };

        const request = new Request(`${this.url}/code/scan`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });

        let response = null;
        try {
            response = await fetch(request);
        } catch (error) {
            console.error('Error scanning:', error);
            this.scanLoop = setTimeout(this.scan, 100);
            return;
        }

        const result = await response.json();
        this.scans.push(result);

        let texts = [];
        for (const scan of this.scans) {
            for (const entity of scan.entities) {
                let text = entity.value;
                if (text.length >= 8 && text.length <= 10) {
                    text = text.substring(text.length - 8);
                }
                texts.push(text);
            }
        }

        texts = texts.filter(text => text.length === 8);

        let counts = {};
        for (const text of texts) {
            counts[text] = (counts[text] || 0) + 1;
        }

        let bestCandidate = null;
        let bestCount = 0;
        for (const text in counts) {
            if (counts[text] > bestCount) {
                bestCount = counts[text];
                bestCandidate = text;
            }
        }

        if (bestCount <= 5) {
            bestCandidate = null;
        }

        if (bestCandidate) {
            this.stop();
            this.onSuccess(bestCandidate);
            return;
        }

        this.scanLoop = setTimeout(this.scan, 100);
    }
}